import React from 'react';
import PropTypes from 'prop-types';

const IconRight = ({ width, height, fill }) => (
    <svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
        <path
            d="M14.986 10.39c-1.315-1.232-1.315-3.232 0-4.465 1.315-1.233 3.447-1.233 4.762 0l15.266 16.842c1.315 1.233 1.315 3.233 0 4.466L19.748 44.075c-1.315 1.233-3.447 1.233-4.762 0-1.315-1.233-1.315-3.233 0-4.466L27.871 25 14.986 10.39z"
            fill={fill}
        />
    </svg>
);

IconRight.propTypes = {
    fill: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
};

IconRight.defaultProps = {
    fill: '#42B4E6',
    className: '',
    width: 10,
    height: 10,
};

export default IconRight;
